export const API_URL =
  (process.env.API_URL as string) || (process.env.NEXT_PUBLIC_API_URL as string)
export const FASTAPI_URL =
  (process.env.FASTAPI_URL as string) ||
  (process.env.NEXT_PUBLIC_FASTAPI_URL as string)

if (!API_URL) {
  console.error('Missing API_URL environment variable')
}

if (!FASTAPI_URL) {
  console.error('Missing FASTAPI_URL environment variable')
}

type ApiVersion = 'v1' | 'v2' | 'v3' | 'v4' | 'oss' | 'fastapi'

export const getApiUrl = ({ version }: { version?: ApiVersion } = {}) => {
  if (version) {
    if (version == 'fastapi') {
      return `${FASTAPI_URL}`
    }
    return `${API_URL}/${version}`
  }
  return API_URL
}
